import { render } from "./CartTotals.vue?vue&type=template&id=e021f5c4&scoped=true"
import script from "./CartTotals.vue?vue&type=script&lang=js"
export * from "./CartTotals.vue?vue&type=script&lang=js"

import "./CartTotals.vue?vue&type=style&index=0&id=e021f5c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e021f5c4"]])

export default __exports__